import { gql } from '@zenbusiness/application-commons-graphql';

import { ATTRIBUTES_FRAGMENT } from '../fragments/AttributesFragment';
import { UI_INSTRUCTION_FRAGMENT } from '../fragments/UiInstructionFragment';

export const SEND_FEEDBACK_MUTATION = gql`
  mutation SendFeedback(
    $identity: Identity!
    $threadUuid: UUID!
    $messageUuid: UUID!
    $feedback: UserFeedback!
  ) {
    sendFeedback(
      identity: $identity
      threadUuid: $threadUuid
      messageUuid: $messageUuid
      feedback: $feedback
    ) {
      ok
      threadUuid
      data {
        id
        type
        attributes {
          ...AttributesFragment
        }
        meta {
          renderStrategy
        }
      }
      error
      meta
    }
  }
  ${ATTRIBUTES_FRAGMENT}
  ${UI_INSTRUCTION_FRAGMENT}
`;
